<template>
  <div>
    <nav-link 
      to="/daily-exercise" 
      icon="home" 
      name="Daily Exercises" 
      id="client-home"
      tutorial="GSE-cX1M2fU"
      v-if="user.profile.allow_daily_exercises" />
    <nav-link
      to="/daily-reflection"
      icon="thumbs_up_down"
      name="Self Reflect"
      :style="{color: notificationColor}"
      id="self-reflect"
      tutorial="p0r848LMKys"
      v-if="user.profile.allow_self_reflect" 
      />
    <nav-link v-if="user.profile.allow_self_reflect" to="/reflection-history" icon="history" name="My Reflection History" />
    <nav-link v-if="user.profile.allow_goals" to="/goals" icon="assessment" name="Work On My Goals" id="goals" tutorial="8lGg-5wmNS4"/>
    <nav-link v-if="user.profile.allow_progress" to="/progress" icon="assessment" name="Check My Progress" id="progress" />
    <nav-link v-if="user.profile.allow_courses" to="/courses" icon="assignment" name="Courses" tutorial="ORhZOnTBcXA"/>
    <nav-link v-if="user.profile.allow_journal" to="/journal" icon="book" name="Journal" id="reflection-history" tutorial="le_kwSHKxL4"/>
    <nav-link v-if="user.profile.allow_assessments" to="/c/assessments" icon="assessment" name="Assessments" id="assessments" tutorial="l4XOwlSb2NU"/>
  </div>
</template>

<script>
import navLink from "./nav";

export default {
  props: ["user", "subDomain", "notificationColor"],
  components: { navLink }
}
</script>
